import { displaySuccess } from "../../utils/messageToast";
import { SetupAuth } from "../../client";

export const createProtocol = async (
    payload: unknown,
    ambient: string,
    authorization?: string,
    skipSuccessToast = false
) => {
    const apiClient = SetupAuth(authorization ?? "");
    const response = await apiClient.post(
        `/create-protocol?ambient=${ambient}`,
        payload,
    );
    if (!skipSuccessToast) {
        displaySuccess("Protocolo criado com sucesso!");
    }
    return response.data;
};